module.exports = __webpack_public_path__ + "img/News_Center.04675efb.png";